import React, { useContext, useEffect } from 'react'
import { Box, Text } from "grommet"

import Spinner from '../common/Spinner'
import { gql, useSubscription } from '@apollo/client';
import UserContext from '../../context/UserContext'
import * as moment from "moment-timezone"

import { TopBar } from './TriageViewUtils'

const JOB_LOG_QUERY = gql`
subscription($taskId: String!) {
    jobtasklog(where: {taskid: {_eq: $taskId}}, order_by: {timestamp: asc}) {
        timestamp
        logginglevel
        message
      }
}
`

function getLogColor(loglevel) {
    if (loglevel === '30') {
        return "accent-4"
    } else if (loglevel === '40' || loglevel === '50') {
        return "status-critical"
    } else {
        return "accent-1"
    }
}

function formatLogs(timezone, eachLog) {

    // \u00a0 is for whitespace
    let loglevel = "INFO\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0"
    if (eachLog.logginglevel === '10') {
        loglevel = "DEBUG\u00a0\u00a0\u00a0\u00a0\u00a0"
    } else if (eachLog.logginglevel === '30') {
        loglevel = "WARNING"
    } else if (eachLog.logginglevel === '40') {
        loglevel = "ERROR\u00a0\u00a0\u00a0\u00a0\u00a0"
    } else if (eachLog.logginglevel === '50') {
        loglevel = "CRITICAL"
    }

    let timestamp_temp = ''
    timestamp_temp = moment(moment(eachLog.timestamp).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
    timestamp_temp = moment(timestamp_temp).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')

    return timestamp_temp + ' | ' + loglevel + ' | ' + eachLog.message
}

export const TriageViewLogHistory = ({ taskid }) => {
    const token = useContext(UserContext)

    const { data: logData, loading: logDataLoading } = useSubscription(
        JOB_LOG_QUERY, { variables: { taskId: taskid } }
    )

    // Generate Text for Download String
    let finalText = ""
    if (!logDataLoading && logData && logData.jobtasklog && logData.jobtasklog.length > 0) {
        logData.jobtasklog.forEach(eachLog => {
            finalText += formatLogs(token.timezone, eachLog)
        });
    }

    // AutoScrolling Behavior
    const messagesEndRef = React.createRef()
    const scrollToBottom = ({ behavior }) => {
        messagesEndRef.current.scrollIntoView({ behavior: behavior })
    }

    // When Streaming in Smooth Scroll
    useEffect(() => {
        scrollToBottom("smooth")
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logData])

    // On First Load Instant Scroll
    useEffect(() => {
        scrollToBottom("instant")
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (

        <Box margin={{ left: '20px', top: '20px', right: '20px', bottom: '20px' }} gap="small">
            <Text name="triageLog" weight='bold'>Triage Log</Text>
            <TopBar text={finalText} />
            <Box
                overflow={{ horizontal: 'hidden', vertical: 'auto' }}
                direction="column"
                margin={{ top: "40px" }}
                pad={{ top: '15px', left: '20px', right: '20px', bottom: '15px' }}
                background="black"
            >
                {logDataLoading && <Spinner />}
                {!logDataLoading && logData && logData.jobtasklog && logData.jobtasklog.length === 0 &&
                    <Text margin={{ bottom: "4px" }} size='13px' color="accent-1">
                        No Logs To Display
                        </Text>
                }
                {!logDataLoading && logData && logData.jobtasklog && logData.jobtasklog.length > 0 &&
                    logData.jobtasklog.map(eachLog => (
                        <Text margin={{ bottom: "4px" }} key={eachLog.timestamp + '_ts'} size='13px' color={getLogColor(eachLog.logginglevel)}>
                            {formatLogs(token.timezone, eachLog)}
                        </Text>
                    ))
                }
                <Box ref={messagesEndRef}></Box>
            </Box>

        </Box>
    )
}

export default TriageViewLogHistory